<template>
  <div class="page_title">
    <div class="align py-3 px-4">
      <h1 class="px-1">
        <RedirectBack></RedirectBack>
        <span>Pré-autorização #{{ preAuthorization.id }}</span>
      </h1>
    </div>
  </div>

  <div v-if="preAuthorization.id" class="align p-4 space_title">
    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="p-4">
              <div class="row">
                <div class="col-12 mb-3">
                  <h5>{{ preAuthorization.title || 'Sem título' }}</h5>
                  <p class="date">{{ $dateFormat(preAuthorization.created_at) }}</p>
                  <span v-if="preAuthorization.status" class="badge" :style="'background-color: ' + preAuthorization.status_color">{{ preAuthorization.status_name }}</span>
                </div>

                <div class="col-12 col-md-6 mb-2">
                  <strong>Referência G1</strong>
                  <p v-if="preAuthorization.references?.g1"><a :href="preAuthorization.references.g1" target="_blank">{{ preAuthorization.references.g1 }}</a></p>
                  <p v-else class="text-muted">Não informado</p>
                </div>

                <div class="col-12 col-md-6 mb-2">
                  <strong>Referência UOL</strong>
                  <p v-if="preAuthorization.references?.uol"><a :href="preAuthorization.references.uol" target="_blank">{{ preAuthorization.references.uol }}</a></p>
                  <p v-else class="text-muted">Não informado</p>
                </div>

                <div class="col-12 col-md-6 mb-2">
                  <strong>Referência R7</strong>
                  <p v-if="preAuthorization.references?.r7"><a :href="preAuthorization.references.r7" target="_blank">{{ preAuthorization.references.r7 }}</a></p>
                  <p v-else class="text-muted">Não informado</p>
                </div>

                <div class="col-12 col-md-6 mb-2">
                  <strong>Referência Metrópoles</strong>
                  <p v-if="preAuthorization.references?.metropoles"><a :href="preAuthorization.references.metropoles" target="_blank">{{ preAuthorization.references.metropoles }}</a></p>
                  <p v-else class="text-muted">Não informado</p>
                </div>

                <div class="col-12 col-md-6 mb-2">
                  <strong>Outra Referência</strong>
                  <p v-if="preAuthorization.references?.other"><a :href="preAuthorization.references.other" target="_blank">{{ preAuthorization.references.other }}</a></p>
                  <p v-else class="text-muted">Não informado</p>
                </div>

                <div class="col-12 col-md-6 mb-2">
                  <strong>Segunda Referência</strong>
                  <p v-if="preAuthorization.references?.other_two"><a :href="preAuthorization.references.other_two" target="_blank">{{ preAuthorization.references.other_two }}</a></p>
                  <p v-else class="text-muted">Não informado</p>
                </div>

                <div class="col-12 mb-3">
                  <strong>Observações</strong>
                  <p v-if="preAuthorization.observation" v-html="preAuthorization.observation"></p>
                  <p v-else class="text-muted">Não informado</p>
                </div>
              </div>
          </div>
        </div>
      </div>
      
      <div class="col-md-4">
        <div class="card">
          <div class="p-4">
            <h6>Imagem</h6>
            <div v-if="preAuthorization.image" class="mt-2">
              <img :src="preAuthorization.image" alt="Imagem da pré-autorização" style="width: 100%; height: auto; border-radius: 8px;" />
            </div>
            <div v-else class="image-placeholder mt-2">
              <p class="text-muted text-center">Nenhuma imagem</p>
            </div>
            
            <div class="mt-3">
              <strong>Referência da Imagem</strong>
              <p v-if="preAuthorization.image_reference" class="mb-0">{{ preAuthorization.image_reference }}</p>
              <p v-else class="text-muted mb-0">Não informado</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script setup>
import RedirectBack from '@/components/RedirectBack.vue'
import { usePreAuthorizationStore } from '@/stores/PreAuthorizationStore'
import { inject, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';

const loader = inject('$loader');

const preAuthorizationStore = usePreAuthorizationStore();
const { preAuthorization } = storeToRefs(preAuthorizationStore);

const route = useRoute();

onMounted(async () => {
  preAuthorizationStore.preAuthorization = {};

  const id = route.params.id;
  if(id){
    loader.show();
    await preAuthorizationStore.getPreAuthorization(id);
    loader.hide();
  }
});
</script>

<style scoped>
.date {
  color: #747474;
  margin-bottom: 10px;
}

.badge {
  font-size: 12px;
  border-radius: 25px;
  padding: 5px 10px;
  font-weight: 600;
  margin-top: 5px;
  display: inline-block;
}

a {
  color: #00bfcf;
  text-decoration: none;
  word-break: break-all;
}

a:hover {
  text-decoration: underline;
}

strong {
  color: #333;
  font-weight: 600;
}

@media (max-width: 768px) {
  .col-md-8, .col-md-4 {
    margin-bottom: 1rem;
  }
}
</style>